import { useMutation, useQueryClient } from '@tanstack/react-query';
import { isArray } from 'lodash';

import deleteUser from 'Api/user/deleteUser';
import { deleteActionText } from 'Const/user/text';
import { useModal } from 'Store/modal';
import { useToast } from 'Store/toast';
import { useLoader } from 'Store/loader';

import { useUserState } from 'View/user/state';

const useDeleteUser = () => {
  const queryClient = useQueryClient();
  const { onOpenToast } = useToast();
  const { onShowLoader, onResetLoader } = useLoader();
  const { onResetModal } = useModal();
  const { updateState, filterState } = useUserState();

  return useMutation({
    mutationFn: async (id) => {
      onShowLoader({ variant: 'loader-primary' });

      return await deleteUser({ id });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['user-list', filterState] });

      onOpenToast({
        status: 'success',
        description: deleteActionText?.successDescrption,
        duration: 5,
        alwaysShow: false,
      });

      updateState({ alertProps: {} });
    },
    onError: (error) => {
      const errorMessage = isArray(error?.response?.data?.errors) ? error?.response?.data?.errors[0]?.message : deleteActionText?.errorDescription;

      updateState({
        alertProps: {
          isOpen: true,
          type: 'error',
          title: deleteActionText?.errorTitle,
          description: errorMessage,
          onClose: () => updateState({ alertProps: {} }),
          marginBottom: '12px',
        },
      });
    },
    onSettled: () => {
      onResetLoader();
      onResetModal();
    },
  });
};

export default useDeleteUser;
